import {Dialog} from '@headlessui/react';
import React, {ReactElement} from 'react';
import {CheckCircleIcon, ExclamationCircleIcon, InformationCircleIcon, XCircleIcon} from "@heroicons/react/solid";
import {ModalContainer, ModalType} from "../ModalContainer";
import {ModalSize} from "../ModalContainer/ModalContainer";

// Constants ----

const icons: Record<ModalType, ReactElement> = {
    [ModalType.INFO]: <InformationCircleIcon className="h-6 w-6 text-brand" aria-hidden="true"/>,
    [ModalType.SUCCESS]: <CheckCircleIcon className="h-6 w-6 text-green-400" aria-hidden="true"/>,
    [ModalType.WARNING]: <ExclamationCircleIcon className="h-6 w-6 text-yellow-400" aria-hidden="true"/>,
    [ModalType.DANGER]: <XCircleIcon className="h-6 w-6 text-red-400" aria-hidden="true"/>,
    [ModalType.ERROR]: <XCircleIcon className="h-6 w-6 text-red-400" aria-hidden="true"/>,
}

// Types ----

type ConfirmModalProps = {
    type?: ModalType
    title: string
    body?: string
    children?: React.ReactNode,
    show: boolean
    approveLabel?: string
    onApprove?: () => Promise<void>
    cancelLabel?: string
    onCancel: () => any
}

// Component ----

function ConfirmModal({type = ModalType.INFO, title, body, children, show, approveLabel, onApprove, cancelLabel, onCancel}: ConfirmModalProps) {
    return (
        <ModalContainer
          type={type}
          show={show}
          onApprove={onApprove}
          onCancel={onCancel}
          approveLabel={approveLabel}
          cancelLabel={cancelLabel}
          size={ModalSize.X_SMALL}
        >
            <div className="flex gap-4">
                <div className="mx-auto flex-shrink-0 flex items-center justify-center h-12 w-12 rounded-full bg-gray-100 sm:mx-0 sm:h-10 sm:w-10">
                    {icons[type]}
                </div>
                <div className="flex flex-col gap-2 pt-3 sm:pt-2">
                    <Dialog.Title as="h3" className="text-lg leading-6 font-medium text-gray-900">
                        {title}
                    </Dialog.Title>
                    <div>
                        {!!body &&
                          <p className="text-sm text-gray-500">
                            {body}
                          </p>
                        }

                        {children}
                    </div>
                </div>
            </div>
        </ModalContainer>
    );
}

ConfirmModal.types = ModalType

export default ConfirmModal;